import { ColumnIndex, ColumnRange } from '../interfaces/ColumnRange';
import { getColumn } from './getColumn';
import { LayoutInterval } from '../interfaces/LayoutInterval';
import { minmax } from './minmax';

/**
 * Gets the range of columns in which the given layout interval appears.
 * @param interval The interval we're interested in.
 * @param columnCount The count of columns in the current view.
 * @param columnLength The length of the columns in the current view.
 */
export function getColumnRange(
    interval: LayoutInterval,
    columnCount: number,
    columnLength: number
): ColumnRange {
    // The inclusive start column index, limited by the columns we have in view.
    const start = getColumnIndex(getColumn(interval.start, columnLength), columnCount);

    // The exclusive end column index, limited by the columns we have in view.
    // Special case empty intervals as if spanning 1 column.
    const isEmpty = interval.start == interval.end;
    const end = isEmpty
        ? start + 1
        : getColumnIndex(Math.ceil(interval.end / columnLength), columnCount);

    return { start, end };
}

function getColumnIndex(value: number, columnCount: number): ColumnIndex {
    return minmax(0, value, columnCount);
}
